<template>
  <TemplatePageGrid :items="notificationUserGrid" :loading="false" content_only>
    <div class="notifications-history">
      <HeaderNotificationListItem
        v-for="(notification, key) in notificationUserGrid"
        :key="key"
        :notification="notification"
        :observer="observer"
        :index="key"
      />
    </div>
  </TemplatePageGrid>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import HeaderNotificationListItem from 'components/header/notification/HeaderNotificationListItem'

export default {
  name: 'settingsPushNotificationsHistory',
  components: {
    HeaderNotificationListItem,
  },
  data() {
    return {
      observer: null,
    }
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 1.0,
    })
  },
  computed: {
    ...mapGetters('notificationUser', ['notificationUserGrid']),
  },
  methods: {
    ...mapActions('notificationUser', ['onNotificationMakeSeen']),
    onSeen(targetIndex) {
      const targetItem = this.notificationUserGrid[targetIndex]
      if (!targetItem.is_seen) {
        let data = {
          notifications: [
            {
              id: targetItem.id,
              type: targetItem.type,
            },
          ],
        }
        setTimeout(() => {
          this.onNotificationMakeSeen({ data }).then(() => {
            targetItem.is_seen = true
          })
        }, 1000)
      }
    },
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return
        }
        this.observer.unobserve(target)
        const targetIndex = target.getAttribute('data-index')
        this.onSeen(targetIndex)
      })
    },
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
}
</script>

<style lang="scss" scoped>
.notifications-history {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(584px, 1fr));
  gap: 20px;
  @media screen and (max-width: 1500px) {
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 10px;
  }
}
</style>
